import { Trans } from '@lingui/react'

import { useOpen } from '@twistopayments/design-system/hooks'

import { Link } from '../../atoms/link'
import { Typography } from '../../atoms/typography'

import { HelpModal } from './help-modal'
import * as styles from './help-modal-action.styles'

type Props = {
  align?: 'start' | 'center'
  onClick?: () => void
}
export const HelpModalAction = ({ align = 'center', onClick }: Props) => {
  const { isOpen, handleOpen, handleClose } = useOpen()

  const handleClick = () => {
    onClick?.()
    handleOpen()
  }

  const links = [
    <Link key="0" css={styles.link} onClick={handleClick}>
      {null}
    </Link>,
  ]

  return (
    <>
      <Typography align={align} fontWeight="medium" variant="b3">
        <Trans components={links} id="helpModal.helpAction" />
      </Typography>
      <HelpModal opened={isOpen} onClose={handleClose} />
    </>
  )
}
